import { useEffect, useRef, useState } from 'react';
import { Dialog, InputNumber, InputTextarea, SelectButton, } from 'primereact';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import useMessage from 'hooks/useMessage';
import { useAuthentication, useTheme } from 'hooks';
import useExceptionHandler from 'hooks/useExceptionHandler';
import { EditSection } from 'components/MiCuenta/EditSection/EditSection';
import './ConfiguracionSection.styles.scss';
import { CompaniaManager, FacturaCitrusManager, SeguridadManager } from "managers";
import ToolTip from 'components/ToolTip/ToolTip';
import { SvgComponent } from 'components';
import 'primeicons/primeicons.css';
import { StringHelper } from 'utils';
import { ERP_URL, PLANES_ECF } from 'utils';


let isListenerActive = false;
export function ConfiguracionCuenta({ showLoading, hideLoading, isActive }) {
    const planesEcf = PLANES_ECF;
    const [tipoPago, setTipoPago] = useState(0)
    const [planSeleccionado, setPlanSeleccionado] = useState([]);

    const { theme } = useTheme();
    const { usuario } = useAuthentication();
    const { Message, Warning } = useMessage();
    const { handleException } = useExceptionHandler();

    const [editar, setEditar] = useState(false);
    const [tipoPlan, setTipoPlan] = useState(['1kT']);

    const [subTotal, setSubtotal] = useState(0);
    const [descuentoAnual, setDescuentoAnual] = useState(0);
    const [montoAnual, setMontoAnual] = useState(0);
    const [pagoModalVisible, setPagoModalVisible] = useState(false);

    const [compania, setCompania] = useState({});
    const [companiaInicial, setCompaniaInicial] = useState({});

    const [configInicial, setConfigInicial] = useState({});
    const [newConfig, setNewConfig] = useState({});
    const [pagoExitoso, setPagoExitoso] = useState(false);

    const dialogPagoRef = useRef();
    const [pagoAnual, setPagoAnual] = useState(false);
    const [tipoPlanECFDiff, setTipoPlanECFDiff] = useState([]);
    const [tarjetaModalVisible, setTarjetaModalVisbile] = useState(false);


    useEffect(() => { if (isActive) { cargarCompania(); } }, [isActive]);
    useEffect(() => {
        setCompaniaInicial(compania);

    }, [usuario, editar]);

    useEffect(() => {
        setTimeout(() => {
            const element2 = document.querySelectorAll('.p-button.p-component');
            if (element2.length > 0) {
                element2.forEach((map) => {
                    if (map.nodeName !== 'BUTTON') {
                        map.style.backgroundColor = 'unset'
                    }
                })
            }
            const element = document.querySelectorAll('.p-button.p-component.p-highlight');
            if (element.length > 0) {
                element.forEach((map) => {
                    map.style.backgroundColor = !editar ? "#868686ff" : theme.color1T
                    map.style.color = !editar ? "#ffffff" : theme.color1;
                })
            }
        }, pagoModalVisible ? 50 : 0)
    }, [editar, compania, tipoPago, pagoModalVisible, planSeleccionado]);

    const Editar = () => {
        if (!compania.ClienteId || compania.ClienteId === 0) {
            Warning({ message: 'Esta Compañía está mal configurada. Contacte con el Administrador para continuar el proceso.' })
            return;
        }
        setEditar(!editar);
    }

    function grabar() {
        showLoading();
        setCompania({ ...compania, Id: usuario.CompaniaId });
        CompaniaManager.editar(compania)
            .then((res) => {
                Message({ message: `Actualizado Exitosamente` });
                cargarCompania();
            })
            .catch((e) => handleException(e))
            .finally(() => hideLoading());
    }

    function obtenerLinkPago(Origen, MontoTransaccion) {
        const facturaRequest = {
            Origen: Origen,
            MontoTransaccion: MontoTransaccion,
        }

        showLoading();
        FacturaCitrusManager.obtenerLinkPagoFactura(facturaRequest)
            .then((res) => {
                if (res.Success && res.Data) {
                    const width = 960;
                    const height = 500;
                    const left = (window.screen.width / 2) - (width / 2);
                    const top = (window.screen.height / 2) - (height / 2);
                    const origin = window.location.origin;

                    const url = `${res.Data.Url}&requestOrigin=${encodeURIComponent(origin)}&origen=${Origen}&montoTransaccion=${MontoTransaccion}`;
                    const popup = window.open(
                        url,
                        "_blank",
                        `width=${width},height=${height},left=${left},top=${top}`
                    );

                    window.removeEventListener("message", handleMessage);
                    if (!isListenerActive) {
                        window.addEventListener("message", handleMessage);
                        isListenerActive = true;
                    }
                } else {
                    handleException(res);
                }
            })
            .catch((err) => handleException(err))
            .finally(() => hideLoading());
    }

    function actualizarFacturaRecurrente() {
        let plan = planesEcf.find((plan) => plan.value === compania.CantidadTransacciones);
        let planAnterior = planesEcf.find((plan) => plan.value === configInicial?.tipoPlanECF?.[0]);
        const newCompania = {
            _TipoPlanEcf: plan.plan,
            _TipoPlanEcfAnterior: planAnterior?.plan,
            ClienteId: compania.ClienteId,
            CantidadTransacciones: compania.CantidadTransacciones,
        }

        showLoading();
        FacturaCitrusManager.actualizarFacturaRecurrente(newCompania)
            .then((res) => {
                if (res.Success && res.Data) {

                } else {
                    handleException(res);
                }
            })
            .catch((err) => handleException(err))
            .finally(() => hideLoading());
    }

    function handleMessage(event) {
        if (event.origin !== ERP_URL) return;
        if (!event.data || !event.data.info || !event.data.info.exito) return;

        if (event.data && event.data.info.exito) {
            Message({ message: `Pago realizado con éxito. Número de Autorización: ${event.data.info.numeroAutorizacion}` });
            actualizarFacturaRecurrente();
            window.setTimeout(() => grabar(), 3000);

            window.removeEventListener("message", handleMessage);
            isListenerActive = false;
        }

    }


    const cargarCompania = async () => {
        try {
            showLoading();
            const data = await SeguridadManager.buscarCompania();
            if (data) {
                data.Id = usuario.CompaniaId;
                setCompania(data);
                setPlanSeleccionado(data?.CantidadTransacciones ?? 1000);
                let configInicial = {
                    tipoPlanECF: [planesEcf.find((plan) => plan.value === data.CantidadTransacciones)?.value ?? 1000],
                }
                setConfigInicial(configInicial);
                setNewConfig(configInicial);
                calculateTotal(pagoAnual);
            }
        } catch (error) {
            handleException(error);
        } finally {
            hideLoading();
        }
    };


    const getStatus = (mod, newConfigArray, initialConfigArray) => {
        if (newConfigArray?.includes(mod.value) && !initialConfigArray?.includes(mod.value)) {
            return { value: mod.value, status: 'A' };
        } else if (!newConfigArray?.includes(mod.value) && initialConfigArray?.includes(mod.value)) {
            return { value: mod.value, status: 'E' };
        } else if (newConfigArray?.includes(mod.value) && initialConfigArray?.includes(mod.value)) {
            return { value: mod.value, status: 'N' };
        }
        return null;
    };

    const processConfigs = (modules, newConfigArray, initialConfigArray) => {
        let diff = modules
            .map(mod => getStatus(mod, newConfigArray, initialConfigArray))
            .filter(Boolean);

        return diff;
    };

    useEffect(() => {
        setTipoPlanECFDiff(processConfigs(planesEcf, newConfig?.tipoPlanECF, configInicial?.tipoPlanECF));
        calculateTotal(pagoAnual);
    }, [newConfig]);

    const PagoBody = () => {
        return (
            <div className='bootstrapiso' style={{ margin: '0 25px' }}>
                <Row>
                    <Col>
                        <EditSection title='Configuracion anterior'>
                            <div className="list-group" style={{ marginBottom: '15px' }}>
                                {configInicial?.tipoPlanECF?.map((tipo) => {
                                    const selectedModulo = planesEcf.find(
                                        (mod) => mod.value === tipo
                                    );
                                    if (selectedModulo) {
                                        return (
                                            <a
                                                href="#"
                                                className="list-group-item list-group-item-action"
                                                key={selectedModulo.value}
                                            >
                                                <div className="d-flex w-100 justify-content-between">
                                                    <h5 className="mb-1" style={{ width: '70%', display: 'flex', flexDirection: 'column' }}>
                                                        Plan de {selectedModulo.label} <small className='text-muted'>Facturacion Electronica</small>
                                                    </h5>
                                                    <small> {StringHelper.formatCurrency(selectedModulo.precio)}</small>
                                                </div>
                                            </a>
                                        );
                                    } else {
                                        return null;
                                    }
                                })}
                            </div>
                        </EditSection>
                    </Col>
                    <Col>
                        <EditSection title='Nueva configuracion'>
                            <div className="list-group" >
                                {tipoPlanECFDiff.map((tipo) => {
                                    const selectedModulo = planesEcf.find(
                                        (mod) => mod.value === tipo.value
                                    );
                                    if (selectedModulo) {
                                        let color;
                                        if (tipo.status === 'N') {
                                            color = '#495057'
                                        } else if (tipo.status === 'E') {
                                            color = 'red'
                                        } else if (tipo.status === 'A') {
                                            color = 'green'
                                        }
                                        return (
                                            <a
                                                href="#"
                                                className="list-group-item list-group-item-action"
                                                key={selectedModulo.value}
                                                style={{ color: color, background: color === 'green' ? 'rgb(0,255,0, 0.1)' : color === 'red' ? 'rgb(255,0,0, 0.1)' : "transparent" }}
                                            >
                                                <div className="d-flex w-100 justify-content-between">
                                                    <h5 className="mb-1" style={{ width: '70%', display: 'flex', flexDirection: 'column' }}>
                                                        Plan de {selectedModulo.label}<small className='text-muted'>Facturacion Electronica</small>
                                                    </h5>
                                                    <small style={{ color: color === 'green' || color === 'red' ? color : '#999' }}>{StringHelper.formatCurrency(selectedModulo.precio)}</small>
                                                </div>
                                            </a>
                                        );
                                    } else {
                                        return null;
                                    }
                                })}
                            </div>
                            <div className='d-flex'>
                                <div style={{ fontSize: 'smaller' }}>
                                    <SvgComponent
                                        iconName="circulo"
                                        style={{
                                            marginLeft: "3px",
                                            marginBottom: "1px",
                                        }}
                                        fill={'#00ff00'}
                                        width="20px"
                                        height="20px"
                                    />
                                    Servicio agregado
                                </div>
                                <div style={{ fontSize: 'smaller' }}>
                                    <SvgComponent
                                        iconName="circulo"
                                        style={{
                                            marginLeft: "3px",
                                            marginBottom: "1px",
                                        }}
                                        fill={'#FF0000'}
                                        width="20px"
                                        height="20px"
                                    />
                                    Servicio eliminado
                                </div>
                            </div>
                        </EditSection>
                    </Col>
                </Row>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    <div
                        className="card mb-4 shadow-sm"
                        style={{ width: '100%' }}
                    >
                        <div className="card-header">
                            <h4 className="my-0 font-weight-normal">
                                Monto a pagar
                            </h4>
                        </div>
                        <div className="card-body" style={{ fontWeight: 'bold' }}>
                            <div className='d-flex justify-content-between'>
                                <h1 className="card-title pricing-card-title" style={{ fontSize: '1.5rem' }}>
                                    Subtotal:
                                </h1>
                                <h1 className="card-title pricing-card-title" style={{ fontSize: '1.5rem' }}>
                                    {pagoAnual ? `${StringHelper.formatCurrency((montoAnual + Math.abs(descuentoAnual)) ?? 0)}`
                                        : (`${StringHelper.formatCurrency((subTotal) ?? 0)}`)
                                    }
                                </h1>
                            </div>
                            <div className='d-flex justify-content-between'>
                                <h1 className="card-title pricing-card-title" style={{ fontSize: '1.5rem' }}>
                                    Descuento:
                                </h1>
                                <h1 className="card-title pricing-card-title" style={{ fontSize: '1.5rem' }}>
                                    {pagoAnual ? (`${StringHelper.formatCurrency(Math.abs(descuentoAnual) ?? 0)}`)
                                        : (`${StringHelper.formatCurrency(0)}`)
                                    }
                                </h1>
                            </div>
                            <div className='d-flex justify-content-between'>
                                <h1 className="card-title pricing-card-title" style={{ fontSize: '1.5rem' }}>
                                    Impuestos:
                                </h1>
                                <h1 className="card-title pricing-card-title" style={{ fontSize: '1.5rem' }}>
                                    {`${StringHelper.formatCurrency(0)}`}
                                </h1>
                            </div>
                            <div className='d-flex justify-content-between'>
                                <h1 className="card-title pricing-card-title" style={{ fontSize: '1.5rem' }}>
                                    Total:
                                </h1>
                                <h1 className="card-title pricing-card-title" style={{ fontSize: '1.5rem' }}>
                                    {pagoAnual
                                        ? `${StringHelper.formatCurrency((montoAnual ?? 0))}`
                                        : `${StringHelper.formatCurrency((subTotal) ?? 0)}`
                                    }
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='d-flex align-items-center mb-4 flex-column'>
                    <SelectButton
                        pt={{
                            button: { style: { width: '150px', borderRadius: '6px', border: `1px solid ${theme.color1}`, color: theme.color1, padding: '0.75rem 0.75rem' } }
                        }}
                        className="d-flex"
                        value={tipoPago}
                        options={[{ name: 'Tarjeta', value: 0 },]}
                        onChange={(e) => setTipoPago(e.value)}
                        optionLabel='name'
                        id="tipoPago"
                        disabled
                    />
                    <div style={{ fontSize: 'smaller' }}>
                        <SvgComponent
                            iconName="circulo"
                            style={{
                                marginLeft: "3px",
                                marginBottom: "1px",
                            }}
                            fill={'#0033ff'}
                            width="20px"
                            height="20px"
                        />
                        Solo se permiten pagos con tarjeta de credito
                    </div>
                </div>

                <Form.Group>
                    <Button type="button" onClick={() => {
                        setPagoModalVisible(false);
                        if (subTotal > 0) {
                            obtenerLinkPago('M', subTotal);
                        } else {
                            actualizarFacturaRecurrente();
                            grabar();
                        }

                    }} className="btn btn-success btn-lg form-control"
                        style={{ backgroundColor: theme.color1, borderRadius: '6px', borderColor: theme.color1, color: 'white' }}
                    >Aceptar</Button>
                </Form.Group>
            </div>
        )
    }

    function calculateTotal(pagoAnual) {

        const nuevoPlan = tipoPlanECFDiff.map((plan) => planesEcf.find((planes) => plan.value === planes.value && plan.status === 'A')).filter(Boolean)[0]
        let costoPlan = (tipoPlan[0] !== null && tipoPlan.length > 0 ? nuevoPlan?.precio ?? 0 : 0)

        let subtotal = 0;
        if (configInicial.tipoPlanECF < nuevoPlan?.value) {
            subtotal = costoPlan;
        }

        setSubtotal(subtotal)
        const montoAnual = (subtotal * 12) - subtotal;
        setMontoAnual(montoAnual * 0.9);
        setDescuentoAnual(montoAnual - (montoAnual * 0.9) + subtotal);
    }

    useEffect(() => calculateTotal(pagoAnual), [pagoAnual, pagoModalVisible]);

    const onHidePagoModal = () => {
        setPagoModalVisible(false);
    }

    useEffect(() => {
        if (pagoExitoso) {
            setPagoExitoso(false)
            setPagoModalVisible(false);
            setTarjetaModalVisbile(false);
            ActualizarCompania();
        }
    }, [pagoExitoso]);

    return (
        <>
            {!compania?.Configuracion?.EsCompaniaPrueba && (
                <Container>
                    <Dialog ref={dialogPagoRef} header='Detalles' visible={pagoModalVisible} style={{ width: '70vw' }} breakpoints={{ '1280': '70vw', '960px': '85vw', '641px': '450px', '400px': '350px' }} onHide={onHidePagoModal}
                        pt={{
                            root: { style: { backgroundColor: '#fff' } },
                            header: { style: { backgroundColor: theme.color1, color: '#fff', borderRadius: '6px', margin: '10px', padding: '10px' } },
                            closeButtonIcon: { style: { color: '#fff' } }
                        }}
                    >
                        {PagoBody()}
                    </Dialog >
                    <div className='d-flex flex-column align-items-center' style={{ width: '100%' }}>
                        {true && (
                            <div className='d-flex justify-content-end' style={{ paddingBottom: '0px', width: '100%' }}>
                                <ToolTip message="Editar" placement="right" style={{ right: 0, position: 'fixed', top: '80px', zIndex: 9999 }}>
                                    <div onClick={Editar}>
                                        <SvgComponent
                                            iconName="pencil"
                                            style={{
                                                cursor: "pointer",
                                                marginLeft: "3px",
                                                marginBottom: "1px",
                                                marginRight: "10px",
                                            }}
                                            width="22px"
                                            height="22px"
                                        />
                                    </div>
                                </ToolTip>
                            </div>
                        )}
                    </div>

                    <Row className='d-flex justify-content-center ' style={{ width: '100%', marginLeft: '0' }}>
                        <Col className='d-flex flex-column align-items-center mb-3'>
                            <h4 className='text-muted'>Planes</h4>
                            <SelectButton
                                pt={{
                                    button: { style: { width: '130px', border: `1px solid ${editar ? theme.color1 : "#868686ff"}`, color: editar ? theme.color1 : "#868686ff", padding: '0.75rem 0.75rem' } },
                                    label: { style: { fontSize: '15px' } }
                                }}
                                className="d-flex custom-select-button"
                                id="int-planesEcf"
                                disabled={!editar}
                                value={planSeleccionado}
                                options={planesEcf}
                                optionLabel="name"
                                onChange={(e) => {
                                    setCompania({
                                        ...compania,
                                        CantidadTransacccionesCompania: e.value,
                                        CantidadTransacciones: e.value
                                    })
                                    setPlanSeleccionado(e.value)
                                    setNewConfig({
                                        ...newConfig,
                                        tipoPlanECF: [e.value]
                                    })
                                }}
                            />
                        </Col>
                    </Row>

                    {editar && (
                        <Row className='d-flex justify-content-center' style={{ width: '100%' }}>
                            <div className='d-flex justify-content-between mb-3' style={{ width: '50%', gap: '20px' }}>
                                <Button type="button" style={{ width: '50%', height: 'auto', backgroundColor: theme.color1, borderRadius: '6px', borderColor: theme.color1, color: 'white' }} onClick={() => {
                                    if (tipoPlanECFDiff?.length > 1) {
                                        setPagoModalVisible(true);
                                    }
                                    else {
                                        Warning({ message: 'Para proceder, debe realizar un cambio en la configuración.' })
                                    }
                                }} className="btn btn-lg form-control">Aceptar</Button>
                                <Button type="button" style={{ width: '50%', height: 'auto', backgroundColor: theme.color1, borderRadius: '6px', borderColor: theme.color1, color: 'white' }} onClick={() => {
                                    setEditar(false)
                                    setCompania(companiaInicial);
                                }} className="btn btn-lg form-control">Cancelar</Button>
                            </div>
                        </Row>
                    )}
                </Container>
            )}
        </>
    )
}